import { SxProps, Theme } from '@mui/material/styles';

export const checkIconSX: SxProps<Theme> = {
    minWidth:'auto',
    paddingRight: 1.5,
    "&>img": {
        height:30,
        width:'auto'
    }
}

export const uspContainerSX: SxProps<Theme> = {
    backgroundColor:'#eef7ec', 
    maxWidth:'fit-content', 
    padding:2,
    color:'#000',
    borderRadius:'8px',
    minHeight:'5em'
}